import type { ComponentProps } from 'react'
import { useSelector } from 'react-redux'

import { getInventoriesListFilters } from '~/store/reducers/inventories'

import SubcategoryFilter from '../filters/SubcategoryFilter'

const InventoryTableSubcategoryFilter = (
  props: ComponentProps<typeof SubcategoryFilter>,
) => {
  const inventoryFilters = useSelector(getInventoriesListFilters)

  return (
    <SubcategoryFilter
      selectedCategoryFilter={inventoryFilters?.categoryIds}
      selectedSubcategoryFilter={inventoryFilters?.subcategoryIds}
      {...props}
    />
  )
}

export default InventoryTableSubcategoryFilter
